import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';
import { RootState } from '../store';
import { canAccessPage, getDefaultPathForUser, PageKey } from '@/auth/accessMatrix';

interface ProtectedRouteProps {
  children: React.ReactNode;
  page?: PageKey;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, page }) => {
  const { isAuthenticated, user } = useSelector((state: RootState) => state.auth);
  const location = useLocation();

  if (!isAuthenticated && location.pathname !== '/login') {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (page && !canAccessPage(user, page)) {
    return <Navigate to={getDefaultPathForUser(user)} replace />;
  }
  
  return <>{children}</>;
}; 